import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import MessageThread from "@/components/MessageThread";

export default function MessagesPage() {
    const [threads, setThreads] = useState([]);
    const [active, setActive] = useState(null);
    const [params] = useSearchParams();
    const preselect = params.get("client");

    const loadInbox = async () => {
        const { data } = await api.get("/messages/inbox");
        setThreads(data);
        if (preselect) {
            const found = data.find((t) => t.id === preselect);
            if (found) { setActive(found); return; }
            // If no thread yet, fetch the client and stub a thread so coach can send the first message
            try {
                const { data: client } = await api.get(`/clients/${preselect}`);
                setActive({ ...client, last_message: null });
            } catch {}
        } else if (!active && data[0]) {
            setActive(data[0]);
        }
    };
    useEffect(() => { loadInbox(); /* eslint-disable-next-line */ }, [preselect]);
    useEffect(() => {
        const t = setInterval(loadInbox, 8000);
        return () => clearInterval(t);
        // eslint-disable-next-line
    }, []);

    return (
        <div className="p-8 space-y-6 h-full" data-testid="messages-page">
            <div>
                <p className="label-tiny mb-2">/ Inbox</p>
                <h1 className="font-serif text-6xl">Messages</h1>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[var(--border)] h-[calc(100vh-220px)]">
                <div className="bg-[var(--surface)] overflow-auto" data-testid="inbox-list">
                    {threads.length === 0 ? (
                        <p className="p-6 text-sm text-[var(--text-muted)]">No threads yet. Start a conversation from any client's profile.</p>
                    ) : threads.map((t) => (
                        <button key={t.id} onClick={() => setActive(t)} data-testid={`thread-row-${t.id}`}
                            className={`w-full text-left p-4 border-b border-[var(--border)] hover:bg-[var(--surface-hover)] ${active?.id === t.id ? "bg-[var(--surface-hover)] border-l-2 border-l-[var(--gold)]" : ""}`}>
                            <div className="flex items-center justify-between mb-1">
                                <p className="font-medium truncate">{t.name}</p>
                                {t.unread > 0 && <span className="font-mono text-[10px] tracking-[0.2em] bg-[var(--gold)] text-[#0a0908] px-2 py-0.5">{t.unread}</span>}
                            </div>
                            <p className="text-xs text-[var(--text-muted)] truncate">
                                {t.last_message.from_role === "coach" ? "You: " : ""}
                                {t.last_message.body}
                            </p>
                            <p className="text-[10px] text-[var(--text-faint)] font-mono mt-1">{new Date(t.last_message.created_at).toLocaleString()}</p>
                        </button>
                    ))}
                </div>
                <div className="md:col-span-2">
                    {active ? (
                        <MessageThread
                            mode="coach"
                            clientId={active.id}
                            api={api}
                            otherName={active.name}
                            onSent={loadInbox}
                        />
                    ) : (
                        <div className="bg-[var(--surface)] h-full flex items-center justify-center text-[var(--text-muted)]">
                            Select a thread.
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
